import { UseQueryResult, useQuery } from 'react-query'

import { QueryKey } from '../../configs/queryKeys'
import { IChatBot, INews, IUser, ISanitizationUser } from '../../interfaces/user'
import { getUser } from '../../services'
import { getNews, getUserSanitization, getBureauUser } from '../../services/users'
import { getChatBot } from '@/services/chat'

export function useGetUserData(): UseQueryResult<IUser> {
  return useQuery([QueryKey.profileUser], getUser, {
    cacheTime: 10 * 60
  })
}

export function useGetChatBot(): UseQueryResult<IChatBot> {
  return useQuery([QueryKey.chatbot], getChatBot, {
    cacheTime: 10 * 60
  })
}

export function useGetnews(): UseQueryResult<INews> {
  return useQuery([QueryKey.news], getNews, {
    enabled: true
  })
}

export function useGetUserSanitization(): UseQueryResult<ISanitizationUser> {
  return useQuery([QueryKey.sanitization], getUserSanitization, {
    enabled: true
  })
}

export const useGetBureauUser = () => {
  return useQuery([QueryKey.bureauUser], getBureauUser, {
    enabled: false,
  });
};
